module.exports = __webpack_public_path__ + "img/BARRENADO_SALA.142815d6.jpg";